import { AlarmRounded } from "@mui/icons-material";
import { DateTime } from "luxon";
import { ItemProperty } from "src/components";

interface Props {
  createdDateTimeUtc: string;
}

const FormSubmissionCreatedProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<AlarmRounded />} label="Created">
      {DateTime.fromISO(props.createdDateTimeUtc, { zone: "utc" }).toLocal().toLocaleString(DateTime.DATE_MED)}
    </ItemProperty>
  );
};

export { FormSubmissionCreatedProperty };
